export default "__VITE_ASSET__CBAwzTla__"